const initialState = {
  token: null,
  isAuthenticated: false,
  isLoading: true,
  firstPassword: true,
  errors: {},
  regError: {},
  email: '',
};

export default function auth(state=initialState, action) {

  switch (action.type) {

    case 'USER_LOADING':
      return {...state, isLoading: true};

    case 'USER_LOADED':
      return {...state, token: action.data, isAuthenticated: true, isLoading: false};

    case 'LOGIN_SUCCESSFUL':
      return {...state, token: action.data.token, isAuthenticated: true,
          isLoading: false, firstPassword: action.data.firstPassword, errors: null,
          email: action.data.email};

    case 'AUTHENTICATION_ERROR':
      return {...state, isAuthenticated: false, isLoading: false, token: null};

    case 'LOGIN_FAILED':
      return {...state, errors: action.data};

    case 'LOGOUT_SUCCESSFUL':
      localStorage.removeItem("token");
      return {...state, errors: action.data, token: null, isAuthenticated: false, firstPassword: true, isLoading: false, email:''};

    case 'PASSWORD_SET':
      return {...state, firstPassword: false};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js